import { Component, OnInit, Input } from '@angular/core';

import { EApiCallStateNames, EApiRequestPartKeys } from '@enums';
import { FsStore } from '@models';

@Component({
  selector: 'prada-fs-search',
  templateUrl: './fs-search.component.html',
  styleUrls: ['./fs-search.component.scss'],
})
export class FsSearchComponent implements OnInit {
  @Input() fsStore: FsStore;

  apiRequestPartKey = EApiRequestPartKeys.SEARCH;
  apiCallStateName = EApiCallStateNames.DOCUMENT_ARCHIVE_LIST;

  constructor() {}

  ngOnInit() {
    this.apiCallStateName = this.fsStore.configuration.apiCallStateName;
  }

  onReset() {}
}
